export default __webpack_public_path__ + "static/media/nft-1@2x.1a8f0fa6.png";